import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import './Customer.css';

const WarrantyActivation: React.FC = () => {
  const [productCost, setProductCost] = useState('');
  const [warrantyDuration, setWarrantyDuration] = useState<number>(1);
  const [productImage, setProductImage] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState<string | null>(null);
  const [paymentAmount, setPaymentAmount] = useState<number | null>(null);
  const navigate = useNavigate();

  const calculatePaymentAmount = (cost: string) => {
    const costNum = parseFloat(cost);
    if (!isNaN(costNum) && costNum > 0) {
      return costNum * 0.7; // 70% of the cost
    }
    return 0;
  };

  const handleCostChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setProductCost(value);
    const amount = calculatePaymentAmount(value);
    setPaymentAmount(amount);
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setProductImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!productImage) {
      setError('Please upload a product image');
      return;
    }

    if (!productCost || parseFloat(productCost) <= 0) {
      setError('Please enter a valid product cost');
      return;
    }

    if (!warrantyDuration || warrantyDuration < 1 || warrantyDuration > 3) {
      setError('Please select a valid warranty duration');
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('productImage', productImage);
    formData.append('productCost', productCost);
    formData.append('warrantyDuration', warrantyDuration.toString());

    try {
      const response = await axios.post('/api/warranty/activate', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      // Redirect to INRPORTAL
      if (response.data.paymentUrl) {
        setPaymentUrl(response.data.paymentUrl);
        window.location.href = response.data.paymentUrl;
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to activate warranty');
    } finally {
      // Keep loading true while redirecting
      if (!paymentUrl) {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <Navbar />
      <div className="container">
        <h1 className="page-title">➕ Activate Warranty</h1>
        <div className="card">
          {!paymentUrl ? (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Cost of the Product (₹)</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={productCost}
                  onChange={handleCostChange}
                  placeholder="Enter product cost"
                  required
                />
              </div>

              {paymentAmount !== null && paymentAmount > 0 && (
                <div className="form-group">
                  <div style={{
                    padding: '12px',
                    backgroundColor: '#e8f5e9',
                    borderRadius: '4px',
                    marginBottom: '16px'
                  }}>
                    <strong>Warranty Payment Amount (70%): ₹{paymentAmount.toFixed(2)}</strong>
                  </div>
                </div>
              )}

              <div className="form-group">
                <label>Warranty Duration</label>
                <select
                  value={warrantyDuration}
                  onChange={(e) => setWarrantyDuration(parseInt(e.target.value))}
                  required
                  style={{ width: '100%', padding: '10px', fontSize: '16px' }}
                >
                  <option value={1}>1 Month</option>
                  <option value={2}>2 Months</option>
                  <option value={3}>3 Months</option>
                </select>
              </div>

              <div className="form-group">
                <label>Product Image</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  required
                />
                {preview && (
                  <img src={preview} alt="Preview" className="image-preview" />
                )}
              </div>

              {error && <div className="error">{error}</div>}
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Generating Payment...' : 'Activate Warranty'}
              </button>
            </form>
          ) : (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <h2>Redirecting to Payment Gateway...</h2>
              <p style={{ marginTop: '20px', color: '#666' }}>
                Please wait while we transfer you to complete your payment.
              </p>
              <div className="loading" style={{ marginTop: '20px' }}></div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default WarrantyActivation;

